import { render, staticRenderFns } from "./WorkLayout.vue?vue&type=template&id=d37d5d42&"
import script from "./WorkLayout.vue?vue&type=script&lang=ts&"
export * from "./WorkLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports